import { apiClient } from 'client/core/network/apiClient';
import { ILdapAuthDto } from 'common/dto/LdapAuthDto';

export const LdapAuthApi = {
  /** Creazione dell'access token per il login tramite credenziali LDAP */
  createAccessToken: (data: ILdapAuthDto) =>
    apiClient.post('/auth/ldap/sso', data)
};
